export default __webpack_public_path__ + "static/media/introBuddyScan.00f4dcd6.svg";